// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__33RQF","title":"Images90_title__N4Ft7","images":"Images90_images__2L6Tk"};